export default "__VITE_ASSET__6a55db59__"